import { apiSlice } from 'state/slices/apiSlice';

const USERS_URL = '/users';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updateUser: builder.mutation({
      query: (data) => {
        return {
          url: `${USERS_URL}/update`,
          method: 'PUT',
          body: data,
        };
      },
    }),
    getUsers: builder.query({
      query: () => `${USERS_URL}/list`,
    }),
    getUser: builder.query({
      query: (userId) => `${USERS_URL}/profile/${userId}`,
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `${USERS_URL}/delete`,
        method: 'DELETE',
        body: { id }
      }),
    }),
    deleteUserProfilePicture: builder.mutation({
      query: (id) => ({
        url: `${USERS_URL}/profilePicture/remove`,
        method: 'DELETE',
        body: { id }
      }),
    }),
  }),
});

export const {
  useGetUsersQuery,
  useGetUserQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useDeleteUserProfilePictureMutation,
} = userApiSlice;
